module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_USB_16"],"path":[{"$":{"d":"M16,7.5l-3-2V7H5.66a10.79,10.79,0,0,0,1.1-1.36A7,7,0,0,1,7.23,5h.61a1.75,1.75,0,1,0,0-1L7.1,4c-.42,0-.7.39-1.15,1s-1.22,1.7-2,1.9a2,2,0,1,0,0,1h.63c.25,0,.79,1,1.05,1.42.51.87.91,1.55,1.5,1.56L9,11v1h3V9H9v1H7.22a4.94,4.94,0,0,1-.74-1.09c-.19-.32-.37-.63-.56-.91H13V9.5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_USB_16.svg
// module id = 0lNn
// module chunks = 1